<template>
    <v-dialog v-model="$store.state.dispatch.qualifications" max-width="1366">
        <v-card>
            <v-toolbar dark color="secondary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text"
                    >Qualifications</v-toolbar-title
                >
                <v-spacer />
                <v-btn
                    icon
                    left
                    @click="$store.state.dispatch.qualifications = false"
                    ><v-icon>mdi-close-circle-outline</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row>
                    <v-col cols="8">
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th>Order</th>
                                    <th>Station</th>
                                    <th>Terminal</th>
                                    <th>ROHrs</th>
                                    <!-- <th>QuadCall</th>
                                    <th>PumpCall</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ order.OrderID }}</td>
                                    <td>{{ order.Station }}</td>
                                    <td>{{ order.Terminal }}</td>
                                    <td>{{ order.ROHrs }}</td>
                                    <!-- <td><v-icon >mdi-{{ order.QuandCall == true ? 'check-circle-outline' : 'close-circle-outline' }}</v-icon></td>
                                    <td><v-icon >mdi-{{ order.PumpCall == true ? 'check-circle-outline' : 'close-circle-outline' }}</v-icon></td> -->
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <br />
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Driver</th>
                            <th>Truck</th>
                            <th>Trailer</th>
                            <th>Yard</th>
                            <th>StartTime</th>
                            <th>Badge</th>
                            <th>QuadCall</th>
                            <th>PumpCall</th>
                            <th>YardCheck</th>
                            <th>Product</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(qlf, idx) in driversBadge"
                            v-bind:key="'qualifcation' + idx"
                        >
                            <td>{{ qlf.Driver }}</td>
                            <td>{{ qlf.Truck }}</td>
                            <td>{{ qlf.Trailer }}</td>
                            <td>{{ qlf.Yard }}</td>
                            <td>{{ qlf.ShiftStartTime }}</td>
                            <td>
                                <v-icon
                                    >mdi-{{
                                        qlf.Badge == true
                                            ? 'check-circle-outline'
                                            : 'close-circle-outline'
                                    }}</v-icon
                                >
                            </td>
                            <td>
                                <v-icon
                                    >mdi-{{
                                        qlf.QuandCall == true
                                            ? 'check-circle-outline'
                                            : 'close-circle-outline'
                                    }}</v-icon
                                >
                            </td>
                            <td>
                                <v-icon
                                    >mdi-{{
                                        qlf.PumpCall == true
                                            ? 'check-circle-outline'
                                            : 'close-circle-outline'
                                    }}</v-icon
                                >
                            </td>
                            <td>
                                <v-icon
                                    >mdi-{{
                                        qlf.YardCheck == true
                                            ? 'check-circle-outline'
                                            : 'close-circle-outline'
                                    }}</v-icon
                                >
                            </td>
                            <td></td>
                            <td><v-btn color="primary" small>Assign</v-btn></td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['order', 'ShiftHeaderNum'],
    data: function() {
        return {
            driversBadge: []
        };
    },
    async mounted() {
        this.getDriverByTerminaBadge();
    },
    methods: {
        getDriverByTerminaBadge: function() {
            var parms = {
                Terminal: this.order.TerminalID,
                Station: this.order.StationID,
                ShiftHeaderNum: this.ShiftHeaderNum
            };
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('driver-badge/qualifications', parms)
                .then(response => {
                    this.driversBadge = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
